import React, { useState, useEffect,} from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import { BaseURL, uniqueToken, } from '../../api/DataApis';
import { GpsBaseURL, Role } from '../../api/DataApis';
import { Link, Navigate, useParams, useLocation } from 'react-router-dom';
import request from '../../Apis/request';
import "./User.css";
import ReactPaginate from 'react-paginate'; 
import { GrTransaction } from 'react-icons/gr';
import Loader from "../Settings/Loader";
import Select from 'react-select';
import { useNavigate } from 'react-router-dom';
import { LuUser } from 'react-icons/lu';
import { useRef } from "react";



  const ManualOrders = () => {
  const [corporateData, setCorporateData] = useState([]);
  const [selectedCorporate, setSelectedCorporate] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadings, setLoadings] = useState(false);
  const [totalCount, setTotalCount] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedStatusType, setSelectedStatusType] = useState("0");
  const [userStatuses, setUserStatuses] = useState({});
  const [page, setPage] = useState(1); // State for current page
  const [pageCount, setPageCount] = useState(0); 
  const [popupInput, setPopupInput] = useState('');
  const [searchQuery, setSearchQuery] = useState("");
  const [filteredData, setFilteredData] = useState([]);
  const [Limit, setLimit] = useState({});
  const [currentPage, setCurrentPage] = useState(1); 
  const [selectStatusType, setselectedStatusType] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [loder, setLoader] =  useState(false);
  const [hasExcel, sethasExcel] =  useState("");

  const [searchTerms, setSearchTerms] = useState({
    srNo: '',
    name: '',
    email: '',
    phone: '',
    meterTransactions: '',
    rfids: '',
    wallet: '',
    status: '',
    createdDate: '',
    actions: ''
  });

  let navigate = useNavigate();
  let location = useLocation();
    let orderStatus = location?.state?.Orderstatus || "";
    let OrderprocessingID = location?.state?.OrderProcessingID || "";
    let OrderProcessingData =  location?.state?.OrderProcessingData || "";
    console.log("orderstatus", orderStatus);
    console.log("ProcessingID", OrderprocessingID);
  const handleSearch = (column, value) => {
    setSearchTerms((prev) => ({
      ...prev,
      [column]: value
    }));
  };
  const fileInputRef = useRef(null);
  const handleButtonClick = (event) => {
    event.preventDefault();
    fileInputRef.current.click(); // Trigger hidden input
  };
  const handleFileChange = (event) => {
    event.preventDefault();
    const file = event.target.files[0];

    if (file) {
      setSelectedFile(file);
      confirmUpload(file); // Ask for confirmation
    }
  };
  const confirmUpload = (file) => {
    Swal.fire({
      title: "Upload Confirmation",
      html: `
        <p>Do you want to upload <strong>${file.name}</strong>?</p>
        <input id="swal-input-title" class="swal2-input" placeholder="Enter Title" />
        <input id="swal-input-comment" class="swal2-input" placeholder="Enter Comment" />
      `,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, upload it!",
      cancelButtonText: "No, cancel!",
      preConfirm: () => {
        const title = document.getElementById("swal-input-title").value;
        const comment = document.getElementById("swal-input-comment").value;
  
        if (!title || !comment) {
          Swal.showValidationMessage(`Please enter both Title and Comment.`);
          return false;
        }
        return { title, comment };
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const { title, comment } = result.value;
        uploadFile(file, title, comment);
      } else {
        setSelectedFile(null); // Reset if canceled
      }
    });
  };
  
  const uploadFile = async (file, title, comment) => {
    const formData = new FormData();
    formData.append("file", file);
    formData.append("title", title);
    formData.append("comment", comment);
  
    setLoader(true);
  
    try {
      const response = await fetch(`${GpsBaseURL}/order/add-manual-excel-order`, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${uniqueToken}`,
        },
        body: formData,
      });
  
      if (response.ok) {
        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "File uploaded successfully.",
          showConfirmButton: false,
          timer: 2000 // Auto-close after 2 seconds (you can adjust the time)
        });
        
        navigate(`/manualorder/order-processing-logs`);
      } else {
        Swal.fire("Error!", "File upload failed.", "error");
      }
    } catch (error) {
      Swal.fire("Error!", "Something went wrong.", "error");
    }
  
    setLoader(false);
  };
  
  
  const handleReset = (event) => {
    event.preventDefault();
  
    if (OrderProcessingData) {
      navigate(`/manualorder/${OrderprocessingID}`, {
        state: {
          OrderProcessingData: OrderProcessingData,
          Orderstatus: orderStatus,
          OrderProcessingID: OrderprocessingID,
        },
      });
    } else {
      navigate(`/manualorder`);
    }
  };
  
 
    const corporateOptions = corporateData.map(corporate => ({
      value: corporate._id,
      label: `${corporate.corporate_name} (${corporate?.email})`,
      _id: corporate._id,
    }));

    const handleDownload = (event) => {
      event.preventDefault()
     sethasExcel("excel");
      
      }
 
  
 
  
  document.title = "Manual Orders";
  const handlecorporateChange = (selectedOption) => {
    console.log("selectedOption:", selectedOption);
    
    if (selectedOption) {
      setSelectedCorporate(selectedOption._id);
    } else {
      setSelectedCorporate(null); // Reset state when cleared
    }
  };
  console.log("selectedCorporate", selectedCorporate);
  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
  };

  
    const fetchCorporatesData = async () => {
      setLoading(true);
      const apiEndpoint = `${GpsBaseURL}/corporate`;
      try {
        const response = await axios.get(apiEndpoint, {
          headers: {
            "Content-type": "application/json; charset=UTF-8",
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        console.log("Countries response", response);
        setCorporateData(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      } finally {
        setLoading(false);
      }
    };
 useEffect(() => {
      if (Role === "false") {
        fetchCorporatesData();  // Only fetch corporate data if Role === "false"
      }
    }, [Role]);

    const fetchUsers = async (page) => {
    setLoadings(true);
    
    // Base API URL
    let apiEndpoint = decodeURIComponent(`${GpsBaseURL}/order?createdType=Manual`);
    if (OrderprocessingID) {
      apiEndpoint = decodeURIComponent(`${GpsBaseURL}/order?createdType=Manual&order-processing-logs&order_processing_log_id=${OrderprocessingID}&order_processing_log_type=${orderStatus}`);
    }
    else if (orderStatus)
    {
    
    }
   
    
    // Prepare query parameters
    const queryParams = [`page=${page}`];
    
    // Add search term to the query params if it's not empty
    // if (searchTerm) queryParams.push(`searchText=${searchTerm}`);
    

   
    if (searchQuery) queryParams.push(`searchText=${searchQuery}`);
    if (selectStatusType) queryParams.push(`status=${selectStatusType}`);
    if(selectedCorporate) queryParams.push(`corporate_id=${selectedCorporate}`);
    if(hasExcel) queryParams.push(`type=${hasExcel}`);
    
    
    const apiUrl = `${apiEndpoint}&${queryParams.join('&')}`;
  
    try {
      // const response = await axios.get(apiUrl, {
      //   headers: {
      //     "Content-type": "application/json; charset=UTF-8",
      //     Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
      //   },
      // });
       const data = {
              headers: {
                "Content-type": "application/json; charset=UTF-8",
                Authorization: `Bearer ${uniqueToken}`, // Replace with actual token if needed
              },
            };
      
            if( hasExcel == "excel" ) {
              data.responseType = "blob";
            }
      
            const response = await axios.get(apiUrl, data);

  
      
      if( hasExcel == "excel" ) {
        // Convert response to blob (response.data contains the blob)
        const blob = new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        
        // Create a download link
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "OrderList.xlsx"; // File name for download
        document.body.appendChild(a);
        a.click();
        sethasExcel("");
        // Cleanup
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);

        return ;
      }
  
      console.log("response", response);
     
      setFilteredData(response.data?.data);
      setTotalCount(response.data.totalCount || 0);
      setLimit(response?.data?.limit);
      setPageCount(Math.ceil(response.data.totalCount / response?.data?.limit)); // Assuming API returns totalCount for pagination
    }  catch (error) {
      console.error("Error fetching users:", error);
    } finally {
      setLoadings(false);
    }
  };
  
  // Re-fetch users whenever searchTerm changes
  useEffect(() => {
    fetchUsers(page);
  }, [searchTerm,  page, hasExcel]);
  


  const handleChange = (setter) => (event) => {
    setter(event.target.value);
  };
  const handlePageClick = (data) => {
    const selectedPage = data.selected + 1; // ReactPaginate uses zero-based index
    setPage(selectedPage); // Update the current page state
  };
   const handleSearchTextChange = (e) => {
  setSearchQuery(e.target.value);
};

// Handle submit to fetch filtered data
const handleSearchSubmit = async (e) => {
  e.preventDefault(); // Prevent default form submission

  const page = 1; // Always reset to page 1 when searching
  setPage(page); // Ensure pagination resets to the first page

  // Set loading to true while fetching
  setLoadings(true); 

  // Prepare the base URL and query parameters
  let url = `${GpsBaseURL}/order?createdType=Manual&page=${page}`;
  if (OrderProcessingData) {
    url = `${GpsBaseURL}/order?createdType=Manual&order-processing-logs&order_processing_log_id=${OrderprocessingID}&order_processing_log_type=${orderStatus}`;
  }
  const params = [];

  // Add search term if present
  if (searchQuery.trim()) {
      params.push(`searchText=${searchQuery}`);
  }
  if (selectedStatusType) {
    params.push(`status=${selectStatusType}`);
}
if(selectedCorporate) {
  params.push(`corporate_id=${selectedCorporate}`);
}


  // Add selected country, state, and city to the params
 
 

  // Append query parameters to the URL
  if (params.length) {
      url += `&${params.join('&')}`;
  }

  try {
      const res = await axios.get(url, {
          headers: {
              Authorization: `Bearer ${uniqueToken}`, // Include authorization token
          },
      });

      if (res && res?.data && res?.data?.data) {
          setFilteredData(res?.data?.data); // Update filtered data
          setTotalCount(res?.data?.data?.length); // Set total count based on the filtered data length
          setPageCount(Math.ceil(res?.data?.totalCount / Limit)); // Update page count based on results
      } else {
          setFilteredData([]); // If no data is returned, set filtered data to empty
          setTotalCount(0); // If no data is returned, set totalCount to 0
      }
      
  } catch (error) {
      console.error("Error fetching filtered data:", error);
  } finally {
      setLoadings(false); // Set loading to false after fetching
  }
};
console.log("filteredDaaata", filteredData);
  return (
    <div className='container-fluid'>
      <div className='row'>
        <div className='col-sm-12'>
          <div className='card'>
            <div className="portlet-body mx-3">
            <div className="d-flex justify-content-between align-items-center mb-3">
  <div className="d-flex align-items-center">
    <h4 className="mb-0 me-3">Manual Orders({totalCount ? totalCount : "Loading..." })</h4> {/* Add margin to the right of the heading */}
   
  </div>
  
  <Link
    className="btn btn-transparent grey-salsa btn-outline btn-sm"
    style={{
      border: "1px solid black",
      borderRadius: "34px",
      display: "inline-flex",
      alignItems: "center",
      overflow: "hidden",
    }}
    to="/manualorder/add"
  >
    <i className="fa fa-plus"></i> Add Order
  </Link>
</div>
<hr style={{ marginTop: "0px" }} />
<div className="row">
  <form className="form-horizontal" role="form" style={{ marginTop: "5px" }}>
    <div
      className="row px-3"
      style={{
        display: "flex",
        alignItems: "center",
        //gap: "10px", // Consistent spacing between filters
        flexWrap: "wrap", // Allow wrapping on smaller screens
      }}
    >
<div className="col-md-2 col-sm-12">
  <div className="form-group">
  <input
    placeholder="Find Data Here"
    className="form-control"
    style={{
      //width: "calc(100% - 150px)", // Increased available width for the input box
      borderRadius: "8px",
      padding: "6px 10px",
      marginRight: "10px",
      height: "38px", // Consistent height
    }}
    value={searchQuery}
    onChange={handleSearchTextChange}
  />
  </div>
</div>
{Role === "false" && (
<div className="col-md-2 col-sm-12"style={{alignItems: "center"}}>
  <div className="form-group">
    <Select
      options={corporateOptions}
      onChange={handlecorporateChange}
      value={corporateOptions?.find(option => option.value === selectedCorporate) || ""}
      placeholder="Corporate"
      isClearable
    
      styles={{
        control: (base) => ({
          ...base,
          height: '38px', 
          width: '100%', // Make width responsive
          boxShadow: 'none',
          minWidth: '0', // Ensures it can shrink below 165px if needed
          flex: 1, // Allow select to grow and shrink
        }),
      }}
    />
  </div>
</div>
)}





<div className="col-md-2 col-sm-12" style={{ display: "flex", alignItems: "center" }}>

    {/* Search Button */}
    <button
      className="btn btn-primary"
      onClick={handleSearchSubmit} // Calls the handleSearchSubmit function
      style={{
        marginLeft: "10px", // Space between the input and button
        height: "38px", // Consistent height
        width: "80px", // Consistent width for the Search button
        display: "flex", // Enable flexbox for centering
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically
        padding: 0, // Ensure no extra padding that could offset centering
      }}
    >
      Search
    </button>

    {/* Reset Button */}
    <button
      className="btn btn-primary"
      onClick={handleReset} // Calls the handleReset function
      style={{
        marginLeft: "10px", // Space between the buttons
        height: "38px", // Consistent height
        width: "80px", // Slightly smaller width for Reset button
        display: "flex", // Enable flexbox for centering
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically
        padding: 0, // Ensure no extra padding that could offset centering
      }}
    >
      Reset
    </button>
    {/* //upload button */}
<button
        className="btn btn-primary"
        onClick={handleButtonClick} // Triggers hidden input
        style={{
          marginLeft: "10px",
          height: "38px",
          width: "190px",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          padding: 0,
        }}
      >
       {loder ? ( 
    <i className="fa fa-spinner fa-spin"></i> // ✅ Loader animation
  ) : (
    <>
      Upload File &nbsp; <i className="fa fa-plus" />
    </>
  )}
      </button>

      {/* Hidden file input */}
      <input
        type="file"
        ref={fileInputRef}
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
         <button
      className="btn btn-primary"
      onClick={handleDownload} // Calls the handleReset function
      style={{
        marginLeft: "10px", // Space between the buttons
        height: "38px", // Consistent height
        width: "80px", // Slightly smaller width for Reset button
        display: "flex", // Enable flexbox for centering
        justifyContent: "center", // Center horizontally
        alignItems: "center", // Center vertically
        padding: 0, // Ensure no extra padding that could offset centering
      }}
    >
      Download
    </button>

</div>

    </div>
  </form>
</div>



              <div className="card-body" style={{ marginLeft: "-19px" }}>
  {loadings ? (
    <Loader /> 
  ) : totalCount === 0 ? (
    <div className="text-center">
      <h5>No User Data Found</h5> {/* Message to indicate no data found */}
    </div>
  ) : (
    <>
    <div className="table-responsive">
      <table
        className="display dataTable"
        id="advance-1"
        style={{ tableLayout: 'auto', width: '100%', borderCollapse: 'collapse' }}
      >
       <thead>
  <tr>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Sr No</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Name</th>
    {Role === "false" && (
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Corporate Name</th>)}
     <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Phone No</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>AWB Date</th>
    {/* <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>AWB Date</th> */}
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>AWB Code</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Serial Number</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Shipment ID</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Order Date</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Order ID</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Payment Status</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Status</th>
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Total Price</th>
 
    {/* <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Created Date</th> */}
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Created By</th>
    {/* <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Updated By</th> */}
    <th style={{ minWidth: '150px', whiteSpace: 'nowrap' }}>Action</th>
 
  </tr>
</thead>

        <tbody>
          {filteredData?.map((user, index) => (
            <tr key={index}>
              <td>{(page - 1) * Limit + index + 1}</td>
 

       <td>{user?.name}</td>
       {Role === "false" &&  (
       <td>{user?.corporate_name}</td>
       )}
    
       <td>{user?.mobile}</td>
       <td>{user?.awb_date}</td>
       <td>{user?.awb_code}</td>
       <td>{user?.serial_number}</td>
       <td>{user?.shipment_id}</td>
       <td>{user?.orderDate}</td>
    
       <td>{user?.orderId}</td>
       <td> <button
    style={{
      width: "106px",
      textAlign: "center",  // Ensures horizontal centering
      padding: "5px",
      fontSize: "12px",
      display: "flex",        // Makes the button a flex container
      justifyContent: "center", // Centers content horizontally
      alignItems: "center",     // Centers content vertically
      backgroundColor: 
        user?.payment_status === 'Pending' ? 'yellow' :
        user?.payment_status === 'Success' ? 'Green' :
        user?.payment_status === 'Failed' ? 'Red' : "purple"
          // Default color
    }}
    className="btn"
  >
    {user?.payment_status}
  </button></td>
      
       <td> <button
    style={{
      width: "106px",
      textAlign: "center",  // Ensures horizontal centering
      padding: "5px",
      fontSize: "12px",
      display: "flex",        // Makes the button a flex container
      justifyContent: "center", // Centers content horizontally
      alignItems: "center",     // Centers content vertically
      backgroundColor: 
        user?.status === 'Pending' ? 'yellow' :
        user?.status === 'Cancelled' ? 'Red' :
        user?.status === 'Placed' ? 'green' :
         user?.status ===  'Shipped' ? 'Orange' : "Purple",  // Default color
    }}
    className="btn"
  >
    {user?.status}
  </button></td>
       <td>{user?.total_price}</td>
   {/* <td>{user?.created_date}</td> */}
   <td>{user?.created_by}</td>
   

             <td> &nbsp;&nbsp;&nbsp;&nbsp;
                                      <Link to={`/orders/view-order/${user?.user_order_id}`} state={{ OrderEditData: user }}>
                                        <i className="fa fa-eye"
                                         title="Edit User"
                                        ></i>
                                      </Link></td>
                        
            </tr>
          ))}   
        </tbody>
      </table>
</div>
    <div className="pagination-container mt-4">
        <ReactPaginate
          previousLabel={'Previous'}
          nextLabel={'Next'}
          breakLabel={'...'}
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageClick}
          containerClassName={'pagination'}
          subContainerClassName={'pages pagination'}
          activeClassName={'active'}
          forcePage={page - 1} 
        />
      </div>
    </>
  )}
</div>

 </div>
      </div>
    </div>
  </div>
</div>
  );
};

export default ManualOrders;
